import { tagColors } from "@/components/tag/tag-colors";
export const TransferOrderEnum = {
  status: {
    DRAFT: 'draft',
    WAIT_REVIEW: 'waitReview',
    REJECTED: 'rejected',
    ABOLISHED: 'abolished',
    WAIT_PICKED: 'waitPicked',
    WAIT_OUTBOUND: 'waitOutbound',
    OUTBOUND: 'outbound',
    COMPLETED: 'completed',
  },
  statusOption: [
    {id: 'draft', text: '草稿',...tagColors.blue},
    {id: 'waitReview', text: '待审核', ...tagColors.orange},
    {id: 'rejected', text: '已驳回', ...tagColors.red},
    {id: 'abolished', text: '已作废', ...tagColors.lightGray},
    {id: 'waitPicked', text: '待拣货', ...tagColors.orange},
    {id: 'waitOutbound', text: '待出库', ...tagColors.orange},
    {id: 'outbound', text: '已出库', ...tagColors.violet},
    {id: 'completed', text: '已完成', ...tagColors.green},
  ],
  logColumns: [
    {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
    {id: 'opUser', header: '操作用户', field: 'createUserName', minWidth: '100px'},
    {id: 'op', header: '操作分类', field: 'option:op', options: [
        {id: 'Add', text: '新增'},
        {id: 'Update', text: '更新'},
        {id: 'Delete', text: '删除'},
        {id: 'Arraignment', text: '提审'},
        {id: 'Pass', text: '通过'},
        {id: 'Reject', text: '驳回'},
        {id: 'Pick', text: '拣货'},
        {id: 'Outbound', text: '出库'},
        {id: 'Abolish', text: '作废'},
        {id: 'MaintainShipment', text: '维护货件'},
      ],
      minWidth: '120px'},
    {id: 'content', header: '操作内容', field: 'content', overflowLine: 2,  minWidth: '300px'}
  ]
};
